import {
  type DeploymentEnv,
  FeatureFlagBrowserClient,
} from '@brokerbay/feature-flags/dist/browser';

/**
 * LaunchDarkly Feaure Flags to be used on the FRONTEND.
 * For Feature Flags that will gate dev features on the backend, edit api/loaders/featureFlagClient.ts
 * Read more about LaunchDarkly FFs here: https://honeywell.atlassian.net/wiki/spaces/ENGKB/pages/533564003/Feature+Flags+LaunchDarkly
 */
export const FEATURE_FLAGS = {
  'retsopenhouse-Bridge': false,
  'retsopenhouse-MLSGrid': false,
  'retsopenhouse-RETS': false,
  'retsopenhouse-SCKMLS': false,
  'retsopenhouse-Spark': false,
  agentInspectionRelabelFeature: false,
  analyticsEnhanceFeature: false,
  analyticsRevampP1Feature: false,
  analyticsRevampP2Feature: false,
  analyticsTableauFeaturePhase: 0,
  analyticsTableauTurnOnFeature: false,
  analyticsTableauUrlV2Feature: false,
  analyticsLegacyTurnOffFeature: false,
  autoConfirmFeature: false,
  autoConfirmSchedulerFeature: false,
  transactionBrokerTypeFeature: false,
  autoUpdateBrokerageDataFeature: false,
  automatonDashboardEnhancementFeature: false,
  clientFeedbackEnhanceFeature: false,
  clientInvitationFeature: false,
  combinedLockboxAssignShacklePermissionsFeature: false,
  customContactDashboardFeature: false,
  masterLockManualCodeFeature: false,
  migrateMatrixFeature: false,
  migrateSmlsFeature: false,
  migrateTrebFeature: false,
  minNoticeFeature: false,
  narSettlementFeature: false,
  narBuyerSettlementFeature: false,
  nonAgentNotificationFeature: false,
  photoSuccessFeature: false,
  preapproveAutomatedCustomContacts: false,
  sanityCheckAssumeFeature: false,
  showingDetailsRevampFeaturePhase: 0,
  showingSettingsFeature: false,
  supraAddUserFeature: false,
  supraBillingApiFeature: false,
  keyholderBillingFeature: false,
  supraIntegrationFeature: false,
  mixpanelFeature: false,
  labelOverridelInAuthFeature: false,
  analyticsTableauTestMlsFeature: 'off',
  showingsMadeEasyFeature: false,
  showingsMadeEasyPhase2Feature: false,
  pusherUpgradeFeature: false, // Remove after v3.87
  quickLockboxAssignmentFeature: false,
  supraLockboxStatusFeature: false,
  supraHideAdminFunctionalityFeature: false,
  supraLockboxPendingGranteesFeature: false,
  manageSupraLockboxStatus: false,
  preBookingNotificationFeature: false,
  preBookingToursNotificationFeature: false,
  supraRebrandingFeature: 0,
  orgAdminFeature: false,
  supraAutoCoopFeature: false,
  mlsStaffActionButtonsFeature: false,
  propertyNotificationsRevampFeature: 0,
  newListingsSearchAPI: false,
  showingNotesFeature: 0,
  clientIdpFeature: {
    enabled: false,
    enabledBoards: [] as string[],
    enabledOrgs: [] as string[],
    idpAllowlist: [] as string[],
  },
  improvedLockboxAssignmentFeature: false,
  supraManualCoopFeature: false,
  chronologicalShowings: false,
  contextualChat: {
    enabled: false,
    enabledMlsTypes: [] as string[],
  },
  LockboxSlowAssignmentEnhancements: false,
  subscriptionHubFeature: false,
  removeAngularFeature: false,
  launchByAssociationFeature: 0,
  dataConnectPhase2Release3Feature: false,
  externalShowingIntegration: false,
  sendPrivateLinkFeature: false,
  mandatoryAccessByAppointmentFeature: false,
  decoupleKeyTypeFeature: false,
  linkAccountFeature: false,
  disableDeleteKeyholderFeature: false,
};

const validDeploymentEnvOpts = ['production', 'staging', 'qa', 'dev', 'env4'];

const deploymentEnvValid = (input = ''): input is DeploymentEnv =>
  validDeploymentEnvOpts.includes(input);

const getDeploymentEnv = (deploymentEnv?: string) => {
  if (!deploymentEnvValid(deploymentEnv)) {
    return 'test';
  }
  return deploymentEnv;
};

// TODO: is this causing bootstrap issue not being ready?
export const featureFlagClient = new FeatureFlagBrowserClient({
  flags: FEATURE_FLAGS,
  serviceName: 'brokerbay-app',
  deploymentEnv: getDeploymentEnv(process.env.DEPLOYMENT_ENV),
  devOverrideFlags: {
    ...(process.env.DEPLOYMENT_ENV === 'dev' &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (process.env.FEATURE_FLAGS as unknown as Record<string, any>)),
  }, // We do this bc webpack makes flags not runtime accessible
  logger: console,
  sendEvents: true,
});

export const { featureEnabled, getFlagValue, getJSON } = featureFlagClient;
